import { render, staticRenderFns } from "./PengecekanTruck.vue?vue&type=template&id=35541fcf&scoped=true"
import script from "./PengecekanTruck.vue?vue&type=script&lang=js"
export * from "./PengecekanTruck.vue?vue&type=script&lang=js"
import style0 from "./PengecekanTruck.vue?vue&type=style&index=0&id=35541fcf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35541fcf",
  null
  
)

export default component.exports